// extracted by mini-css-extract-plugin
module.exports = {"container":"FrontpageContactPart_container__PNSW2","header":"FrontpageContactPart_header__kI7qH","links":"FrontpageContactPart_links__6NBIG"};